export function clone<T>(value: T): T {
    if (typeof structuredClone === "function") {
        try {
            return structuredClone(value);
        } catch {
            // Falls through to JSON when structuredClone refuses the input
            // (functions, proxies, React elements, etc.).
        }
    }
    return JSON.parse(JSON.stringify(value));
}
